import { useContext } from 'react'

import { PoleasSearchForm } from './forms/PoleasSearchForm'
import { poleasContext } from '@/pages/poleas/PoleasImportsPage'

export const PoleasSearch = () => {
  const { updateFilter, filter } = useContext(poleasContext)

  return (
    <PoleasSearchForm
      filter={filter}
      onSubmit={updateFilter}
    />
  )
}
